import { render } from "./LabeledSelect.vue?vue&type=template&id=bd5e330e&scoped=true"
import script from "./LabeledSelect.vue?vue&type=script&lang=js"
export * from "./LabeledSelect.vue?vue&type=script&lang=js"

import "./LabeledSelect.vue?vue&type=style&index=0&id=bd5e330e&lang=scss&scoped=true"

import exportComponent from "../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd5e330e"]])

export default __exports__